import { cloneDatalayerZone, Datalayer, IGeometryInstance } from "../../../omnia"
import { cleanupLayer, MinimumZoneArea } from "../../../utils"
import { clipGeometry } from "../../utils"
import { createMissingZones } from "./modify"

import IMapTopologyService = omnia.map.IMapTopologyService

export function clipLayerZones(layer: Datalayer, topo: IMapTopologyService, outerBoundary: IGeometryInstance) {

    const outer = topo.getGeometry(outerBoundary, true)

    for (const zone of [...layer.zones]) {

        let geom = zone.geometry

        if (geom) {

            const r = clipGeometry(topo, outer, geom, MinimumZoneArea)

            if (r.remove) {
                layer.removeZone(zone)
            }
            else if (r.result) {

                geom = r.result.getOpenLayersGeometry()

                const polygons = omnia.map.getPolygonsAsArray([geom])

                const n = polygons.length

                if (n == 0) {

                    layer.removeZone(zone)

                }
                else if (n == 1) {

                    zone.feature.setGeometry(geom)

                }
                else if (polygons.length > 1) {

                    zone.feature.setGeometry(polygons[0])

                    for (const p of polygons.slice(1)) {
                        const nz = layer.createNewZoneWithGeometry(p, cloneDatalayerZone(zone.zone))
                        nz.setValue(zone.value, false)
                    }

                }

            }


        }

    }

    createMissingZones(layer, topo, outerBoundary)

    // 210922 - Usersnap 2281
    // If this is a Terramap layer, then use an alternate cleaning procedure,
    // which will also remove very small zones
    // This should generally be done when importing TM layers, but some very, very small zones
    // could still be left
    if (layer.datalayer?.TerraMap) {
        omnia.map.cleanupAndRemoveSmallZones(layer)
    }
    else {
        cleanupLayer(layer)
    }

}
